import { render, staticRenderFns } from "./UserPurchases.vue?vue&type=template&id=51352e38&scoped=true&"
import script from "./UserPurchases.vue?vue&type=script&lang=js&"
export * from "./UserPurchases.vue?vue&type=script&lang=js&"
import style0 from "./UserPurchases.vue?vue&type=style&index=0&id=51352e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51352e38",
  null
  
)

export default component.exports